import type { User, UserDetail, UserListItem } from '../types/user';

/**
 * Map a backend UserListItem to the legacy User shape used by view components.
 */
export function userListItemToView(u: UserListItem): User {
  return {
    id: String(u.id),
    name: [u.firstName, u.secondName].filter(Boolean).join(' ') || 'Unknown',
    email: u.workEmail || u.personalEmail || '',
    phone: u.workPhone || u.personalPhone || '',
    role: u.jobTitle || '',
    team: u.team || '',
    status: u.status === 1 ? 'active' : 'offline',
    activeJobs: u.activeJobs,
    completedJobs: u.completedJobs,
    accountType: u.accountType === 2 ? 'third-party' : 'normal',
    isMobileUser: u.isMobileUser,
  };
}

/**
 * Map a backend UserDetail to the legacy User shape used by view components.
 */
export function userDetailToView(u: UserDetail): User {
  const teamName = u.teams?.length
    ? u.teams.map((t: { id: number; name: string }) => t.name).join(', ')
    : '';
  return {
    id: String(u.id),
    name: [u.firstName, u.secondName].filter(Boolean).join(' ') || 'Unknown',
    email: u.workEmail || u.personalEmail || '',
    phone: u.workPhone || u.personalPhone || '',
    role: u.jobTitle || '',
    team: teamName,
    status: u.status === 1 ? 'active' : 'offline',
    activeJobs: 0,
    completedJobs: 0,
    accountType: u.accountType === 2 ? 'third-party' : 'normal',
  };
}
